import React from 'react';
import PropTypes from 'prop-types';
import './RoundButton.css';

const RoundButton = ({ letter, onClick }) => {
    return (
        <button className="round-button" onClick={onClick}>
            {letter}
        </button>
    );
};

RoundButton.propTypes = {
    letter: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default RoundButton;